'use client'

import { useMemo, useState } from 'react';
import { SignInModal } from './SignInModal';
import styles from './ReplyBox.module.css';
import { authClient } from '@/utils/auth-client';
import { getAuthRedirectUrl } from '@/utils/auth-redirect';

interface SignInButtonProps {
  redirectTo?: string;
}

export function SignInButton({ redirectTo }: SignInButtonProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const { data: session } = authClient.useSession();

  const finalRedirectTo = useMemo(() => getAuthRedirectUrl(redirectTo), [redirectTo]);

  const handleClick = () => {
    if (session?.user) {
      window.location.assign(finalRedirectTo);
      return;
    }

    setModalOpen(true);
  };

  return (
    <>
      <button
        onClick={handleClick}
        className={styles.signInButton}
        aria-label="Sign in"
      >
        Sign In
      </button>
      <SignInModal open={modalOpen} onOpenChange={setModalOpen} redirectTo={redirectTo} />
    </>
  )
}

